export const tutorialEn = {
    'tutorial.list.workforce.title': 'Assign Workers',
    'tutorial.list.workforce.description': 'Hire lumberjacks and assistants to see wood flow.',
    'tutorial.list.workforce.steps.jobs.title': 'Assign workers',
    'tutorial.list.workforce.steps.jobs.description': 'Hire lumberjacks and assistants.',
    'tutorial.list.weapons.title': 'Forge First Weapons',
    'tutorial.list.weapons.description': 'Build a blacksmith and craft your first weapons.',
    'tutorial.list.weapons.steps.setup.title': 'Establish industry',
    'tutorial.list.weapons.steps.setup.description': 'Build smelter and blacksmith.',
    'tutorial.list.weapons.steps.production.title': 'Craft weapons',
    'tutorial.list.weapons.steps.production.description': 'Produce your first weapon batch.',
    'tutorial.list.starvation.title': 'Food Supply',
    'tutorial.list.starvation.description': 'Recover from low food and stop starvation.',
    'tutorial.list.starvation.steps.outlook.title': 'Check food outlook',
    'tutorial.list.starvation.steps.outlook.description': 'Review food supply and shortages.',
    'tutorial.list.starvation.steps.jobs.title': 'Assign food workers',
    'tutorial.list.starvation.steps.jobs.description': 'Hire farmers and hunters.',
    'tutorial.list.cold.title': 'Heat Supply',
    'tutorial.list.cold.description': 'Produce fuel to prevent cold deaths.',
    'tutorial.list.cold.steps.outlook.title': 'Check heat outlook',
    'tutorial.list.cold.steps.outlook.description': 'Review heating demand and fuel.',
    'tutorial.list.cold.steps.jobs.title': 'Assign burners',
    'tutorial.list.cold.steps.jobs.description': 'Hire burners and assistants.',
    'tutorial.workforce.step1.title': 'Open your settlement',
    'tutorial.workforce.step1.body': 'Tap the highlighted city to open its details.',
    'tutorial.workforce.step2.title': 'Go to Jobs tab',
    'tutorial.workforce.step2.body': 'Open the Jobs tab to manage workers.',
    'tutorial.workforce.step3.title': 'Assign lumberjacks',
    'tutorial.workforce.step3.body': 'Hire %d lumberjacks to start cutting trees.',
    'tutorial.workforce.step4.title': 'Check production',
    'tutorial.workforce.step4.body': 'Switch to Production to see wood output.',
    'tutorial.workforce.step5.title': 'Return to Jobs',
    'tutorial.workforce.step5.body': 'Go back to Jobs to assign assistants.',
    'tutorial.workforce.step6.title': 'Assign assistants',
    'tutorial.workforce.step6.body': 'Hire %d assistants to move wood.',
    'tutorial.workforce.step7.title': 'Check storage',
    'tutorial.workforce.step7.body': 'Open Storage to see gathered resources.',
    'tutorial.starvation.step1.title': 'Open your settlement',
    'tutorial.starvation.step1.body': 'Tap the highlighted city to review food needs.',
    'tutorial.starvation.step2.title': 'Check food outlook',
    'tutorial.starvation.step2.body': 'Open Population to see food shortages.',
    'tutorial.starvation.step3.title': 'Go to Jobs tab',
    'tutorial.starvation.step3.body': 'Open Jobs to assign food workers.',
    'tutorial.starvation.step4.title': 'Open food jobs',
    'tutorial.starvation.step4.body': 'Switch to the Food jobs tab.',
    'tutorial.starvation.step5.title': 'Assign farmers',
    'tutorial.starvation.step5.body': 'Hire %d farmers to grow food.',
    'tutorial.starvation.step6.title': 'Assign hunters',
    'tutorial.starvation.step6.body': 'Hire %d hunters to gather food.',
    'tutorial.starvation.step7.title': 'Assign assistants',
    'tutorial.starvation.step7.body': 'Hire %d assistants to move food to homes.',
    'tutorial.starvation.step8.title': 'Recheck food outlook',
    'tutorial.starvation.step8.body': 'Return to Population to confirm improvement.',
    'tutorial.cold.step1.title': 'Open your settlement',
    'tutorial.cold.step1.body': 'Tap the highlighted city to review heat needs.',
    'tutorial.cold.step2.title': 'Check heat outlook',
    'tutorial.cold.step2.body': 'Open Population to see heating demand.',
    'tutorial.cold.step3.title': 'Go to Jobs tab',
    'tutorial.cold.step3.body': 'Open Jobs to assign burners.',
    'tutorial.cold.step4.title': 'Open industry jobs',
    'tutorial.cold.step4.body': 'Switch to the Industry jobs tab.',
    'tutorial.cold.step5.title': 'Assign burners',
    'tutorial.cold.step5.body': 'Hire %d burners to produce charcoal.',
    'tutorial.cold.step6.title': 'Assign assistants',
    'tutorial.cold.step6.body': 'Hire %d assistants to move fuel to homes.',
    'tutorial.cold.step7.title': 'Recheck heat outlook',
    'tutorial.cold.step7.body': 'Return to Population to confirm improvement.',
    'tutorial.weapons.step1.title': 'Open your settlement',
    'tutorial.weapons.step1.body': 'Tap the highlighted city to begin.',
    'tutorial.weapons.step2.title': 'Open Buildings tab',
    'tutorial.weapons.step2.body': 'Switch to Buildings to start construction.',
    'tutorial.weapons.step3.title': 'Open Craft buildings',
    'tutorial.weapons.step3.body': 'Choose the Craft sub-tab.',
    'tutorial.weapons.step4.title': 'Build a blacksmith',
    'tutorial.weapons.step4.body': 'Queue a blacksmith to produce weapons.',
    'tutorial.weapons.step5.title': 'Open Support buildings',
    'tutorial.weapons.step5.body': 'Switch to the Support sub-tab.',
    'tutorial.weapons.step6.title': 'Build barracks',
    'tutorial.weapons.step6.body': 'Queue barracks for militia.',
    'tutorial.weapons.step7.title': 'Open Jobs tab',
    'tutorial.weapons.step7.body': 'Go to Jobs to assign workers.',
    'tutorial.weapons.step8.title': 'Open Craft jobs',
    'tutorial.weapons.step8.body': 'Switch to the Craft jobs sub-tab.',
    'tutorial.weapons.step9.title': 'Assign smiths',
    'tutorial.weapons.step9.body': 'Hire a smith to craft weapons.',
    'tutorial.weapons.step10.title': 'Open Production tab',
    'tutorial.weapons.step10.body': 'Switch to Production to tune the blacksmith.',
    'tutorial.weapons.step11.title': 'Set tool target',
    'tutorial.weapons.step11.body': 'Set the tool target to %d.',
    'tutorial.weapons.step12.title': 'Set weapon target',
    'tutorial.weapons.step12.body': 'Set the weapon target to %d.',
    'tutorial.weapons.step13.title': 'Return to Jobs',
    'tutorial.weapons.step13.body': 'Go back to Jobs to assign support roles.',
    'tutorial.weapons.step14.title': 'Open Support jobs',
    'tutorial.weapons.step14.body': 'Switch to the Support jobs sub-tab.',
    'tutorial.weapons.step15.title': 'Assign militia',
    'tutorial.weapons.step15.body': 'Hire %d militia for scouting.',
    'tutorial.weapons.step16.title': 'Check weapons',
    'tutorial.weapons.step16.body': 'Open Production and watch weapon progress.',
    'tutorial.weapons.step17.title': 'Open hostile tile',
    'tutorial.weapons.step17.body': 'Tap the highlighted region with hostiles.',
    'tutorial.weapons.step18.title': 'Open scouting',
    'tutorial.weapons.step18.body': 'Start a scouting mission.',
    'tutorial.weapons.step19.title': 'Send scouts',
    'tutorial.weapons.step19.body': 'Set troops and send the scouts.',
    'tutorial.weapons.step20.title': 'Review battle report',
    'tutorial.weapons.step20.body': 'Open the battle details.',
    'tutorial.weapons.step21.title': 'Return troops',
    'tutorial.weapons.step21.body': 'Order scouts to return.',
    'tutorial.done.title': 'Tutorial complete',
    'tutorial.done.body': 'Excellent! Exit tutorial when you are ready.',
};

export default tutorialEn;
